export default __webpack_public_path__ + "static/media/slider-image4.cbdb3102.jpg";